import { isNilOrEmptyString } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { PKUrl, SidebarInfo, SidebarInfoColumn } from 'components';
import SidebarSection from 'components/atoms/GefMui/SidebarSection';
import { getLeadData } from 'features/views/leadDetail/selectors';
import taskDetail from 'features/views/taskDetail';
import { equalOrThreeDashes, mailToLink, phoneToLink } from 'utils';
import { getClientName } from 'utils/client';

const { getStringOrOneOf } = taskDetail.utils;

export const SidebarClientInfo = () => {
	const leadDetail = useSelector(getLeadData);

	const { metadata = {}, client = {}, clientLoadedFromCcd, id } = leadDetail;
	const { common = {} } = metadata;
	const { id: partnerId, address = {} } = client;

	const name = getClientName(client);
	const street = getStringOrOneOf(address.street, address.streetNo);

	const data = [
		{
			attribute: getLabelMessage('leadDetail:sidebarBusinessIn'),
			insideValue: client.businessIn,
			finalValue: equalOrThreeDashes(client.businessIn),
		},
		{
			attribute: getLabelMessage('leadDetail:sidebarStreet'),
			insideValue: street,
			finalValue: equalOrThreeDashes(street),
		},
		{
			attribute: getLabelMessage('leadDetail:sidebarCity'),
			insideValue: address.municipality,
			finalValue: equalOrThreeDashes(address.municipality),
		},
		{
			attribute: getLabelMessage('leadDetail:sidebarPSC'),
			insideValue: address.zipCode,
			finalValue: equalOrThreeDashes(address.zipCode),
		},
		{
			attribute: getLabelMessage('leadDetail:sidebarPhone'),
			insideValue: client.phone,
			finalValue: phoneToLink(client.phone, true),
		},
		{
			attribute: getLabelMessage('leadDetail:sidebarEmail'),
			insideValue: client.email,
			finalValue: mailToLink(client.email, true),
		},
		{
			attribute: getLabelMessage('leadDetail:sidebarContactPhone'),
			insideValue: common.phone || common.clientCellPhone || common.clientPhone || client.kclPhone,
			finalValue: phoneToLink(
				common.phone || common.clientCellPhone || common.clientPhone || client.kclPhone,
				true,
			),
		},
		{
			attribute: getLabelMessage('leadDetail:sidebarContactEmail'),
			insideValue: common.email || common.clientEmail || client.kclEmail,
			finalValue: mailToLink(common.email || common.clientEmail || client.kclEmail, true),
		},
	];

	return (
		<SidebarSection heading={getLabelMessage('leadDetail:sidebarLeadDetailClientInfo')}>
			<SidebarInfo>
				{!isNilOrEmptyString(name) && (
					<SidebarInfoColumn
						attribute={getLabelMessage('leadDetail:sidebarName')}
						value={
							<PKUrl.PKPartner partnerId={clientLoadedFromCcd && partnerId} taskId={id} unlock muiLink>
								{equalOrThreeDashes(name)}
							</PKUrl.PKPartner>
						}
					/>
				)}
				{data.map(
					(item) =>
						!isNilOrEmptyString(item.insideValue) && (
							<SidebarInfoColumn attribute={item.attribute} value={item.finalValue} />
						),
				)}
			</SidebarInfo>
		</SidebarSection>
	);
};

export default SidebarClientInfo;
